import { render, staticRenderFns } from "./BackorderItemList.vue?vue&type=template&id=4aeb61be&scoped=true&"
import script from "./BackorderItemList.vue?vue&type=script&lang=js&"
export * from "./BackorderItemList.vue?vue&type=script&lang=js&"
import style0 from "./BackorderItemList.vue?vue&type=style&index=0&id=4aeb61be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb61be",
  null
  
)

export default component.exports